import React from 'react';
import SheetContainer, {
    CloseButton,
    Content,
    Header,
    Heading,
    Overlay,
    Sheet,
} from '../../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import TagsToolContent from '../TagsToolContent';
import { TagsToolbarPopupProps } from '../popup/TagsToolbarPopup';
import { UseTagPopupsStateReturn } from '../hooks/useTagPopupsState';

export const TAGS_SHEET_DEFAULT_SNAP_POINT = 0.5;

export type MobileTagsSheetProps = TagsToolbarPopupProps &
    UseTagPopupsStateReturn & {
        sheetProps: UseSheetReturnType;
    };

const MobileTagsSheet: React.FC<MobileTagsSheetProps> = (props) => {
    const { sheetProps, handleClickEdit } = props;
    const translate = useTranslator('popup', 'tags.sheet');

    return (
        <SheetContainer
            className="tags-tool"
            {...sheetProps}
            defaultSnapPoint={TAGS_SHEET_DEFAULT_SNAP_POINT}
            snapPoints={[0.5, 0.9]}
        >
            <Overlay />
            <Sheet>
                <Header>
                    <Heading>{translate('heading')}</Heading>
                    <CloseButton />
                </Header>
                <Content>
                    <div className="p-5">
                        <TagsToolContent {...props} handleClickEdit={handleClickEdit} />
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileTagsSheet;
